import { createSelector } from 'reselect';
import { AVAILABILITY_MANAGEMENT_WRITER } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const getHasAvailabilityManagementWriter = createSelector(getScopes, scopes => scopes.includes(AVAILABILITY_MANAGEMENT_WRITER));